import React, { useEffect, useCallback } from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import BrowserCategory from "./BrowserCategory";
import { ChevronRight, ChevronLeft } from "react-feather";
import { useSelector, useDispatch } from "react-redux";
import { getGroupRelatedJobIdAction } from "store/Home";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`scrollable-auto-tabpanel-${index}`}
      aria-labelledby={`scrollable-auto-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

// function a11yProps(index) {
//   console.log('index', index)
//   return {
//     id: `scrollable-auto-tab-${index}`,
//     "aria-controls": `scrollable-auto-tabpanel-${index}`,
//   };
// }

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    width: "100%",
    backgroundColor: theme.palette.background.paper,
  },
}));

export default function ScrollableTabsButtonAuto() {
  const classes = useStyles();
  const [value, setValue] = React.useState(1);
  const [tab, setTab] = React.useState();
  const selector = useSelector((state) => state.Home.home);
  const dispatch = useDispatch();
  const incrementCounter = async (payload) =>
    await dispatch(getGroupRelatedJobIdAction(payload));

  // const a11yProps = (index) => console.log(index)

  // useCallback(
  // [dispatch]
  // )
  // const dispatch = useDispatch(dispatch => console.log("venkategcvehfvhvsuh", dispatch(getGroupRelatedJobIdAction(1))))
  // console.log('dispatch', dispatch)

  useEffect(() => {
    // Update the document title using the browser API
    // document.title = `You clicked ${count} times`;
    setTab(selector.GROUPS.Data);
    // incrementCounter(value);
    // setDATA(selector.GETGROUPRELATEDJOBID.Data)
  }, []);

  const handleChange = (event, newValue) => {
    setValue(newValue);
    // setDATA()
    // if(newValue) {
    incrementCounter(newValue);
    // setDATA(selector.GETGROUPRELATEDJOBID.Data)
    // }
    // console.log(DATA)
  };
  const data1 = (data) => {};

  return (
    <div>
      <div className=" lg:mt-16 md:mt-16 mt-10 lg:mb-8 md:mb-8 mb-4">
        <h2 className="fsize28 sm-fsize16 font-bold">BROWSE BY CATEGORY</h2>

        {/* <div className="flex justify-between items-center">
          <h2 className="fsize14 cust-textmuted ">25 Results</h2>
          <div className="flex ">
            <ChevronLeft
              width="30px"
              height="30px"
              className="trend-left-i mr-2"
            />
            <ChevronRight
              width="30px"
              height="30px"
              className="trend-right-i"
            />
          </div>
        </div> */}
      </div>
      <div className="flex relative my-4">
        {/* <div className="b-categ-pagin">
          <ChevronLeft className="browser-left-i" />
          <ChevronRight className="brow-r-blue" />
        </div> */}
        <div className=" flex w-full justify-evenly whitespace-nowrap	cust-categoryscroll-h">
          <div className={classes.root}>
            <AppBar position="static" color="default">
              <Tabs
                value={value}
                onChange={handleChange}
                // indicatorColor="primary"
                textColor="primary"
                variant="scrollable"
                scrollButtons="auto"
                aria-label="scrollable auto tabs example"
                className="bg-white"
              >
                {
                  // props
                  tab &&
                    tab.map((data,index) => {
                      return (
                        <Tab
                          label={data.g_title}
                          value={
                            data[0] ? () => setValue(data.g_value) : data.g_value
                          }
                          key={index}
                        />
                      );
                    })
                }
                {/* <Tab label="Commercial Banking" {...a11yProps(0)} />
                <Tab label="Campus Selection" {...a11yProps(1)} />
                <Tab label="Human Resource" {...a11yProps(2)} />
                <Tab label="Data Science" {...a11yProps(3)} />
                <Tab label="Security Engineer" {...a11yProps(4)} />
                <Tab label="Commercial Banking" {...a11yProps(5)} />
                <Tab label="Data Science" {...a11yProps(6)} /> */}
              </Tabs>
            </AppBar>
            {/* <TabPanel value={value} index={0}>
              <BrowserCategory />
            </TabPanel>
            <TabPanel value={value} index={1}>
              Item Two
            </TabPanel>
            <TabPanel value={value} index={2}>
              Item Three
            </TabPanel>
            <TabPanel value={value} index={3}>
              Item Four
            </TabPanel>
            <TabPanel value={value} index={4}>
              Item Five
            </TabPanel>
            <TabPanel value={value} index={5}>
              Item Six
            </TabPanel> */}
            <TabPanel value={value} index={value}>
              {/* {
                  selector.GETGROUPRELATEDJOBID.Data && selector.GETGROUPRELATEDJOBID.Data.map((data) => {
                    return (
                      )
                    })
                  } */}
              <BrowserCategory
                data={
                  selector.GETGROUPRELATEDJOBID
                    ? selector.GETGROUPRELATEDJOBID.Data
                    : ""
                }
              />
            </TabPanel>
          </div>
        </div>
      </div>
    </div>
  );
}
